export const JointAccountTypes = {
    Primary: "PrimaryAccountHolder",
    Secondary: "SecondaryAccountHolder"
} as const;

export type JointAccountType = typeof JointAccountTypes[keyof typeof JointAccountTypes];
